module.exports = __webpack_public_path__ + "img/dark-and-stormy.3662f6be.jpg";